import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'

export default function Loading() {
  return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', maxHeight: '100%', width: '100vw', maxWidth: '100%' }}>
    <LoadingOutlined style={{ fontSize: 200 }} spin={true} />
  </div>
}